import styled from 'styled-components';

const WrapperLoading = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  min-height: 80px;

  div:nth-child(1) {
    position: relative;
  }
`;
export { WrapperLoading };
